/*
 * Copyright (C) 2019 SADE Innovations Oy - All Rights Reserved
 *
 * NOTICE: This software is owned by SADE Innovations Oy and licensed under SADE Booster license.
 * All dissemination, usage, modification, copying, reproduction, selling and distribution of the
 * software and its intellectual and technical concepts are strictly forbidden without a valid license.
 * Such license can be obtained by issuing a SADE Booster License agreement from SADE Innovations Oy
 * (https://sadeinnovations.com).
 */

import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { AuthWrapper, OtaManager, EventsRepository } from "@sade/data-access";
import AnalyticsView from "../analytics-view";
import SupportView from "../support-view";
import UserView from "../../components/user-view";
import Paths from "../Paths";
import AdminView from "../admin-view";

interface Props {}

export default class ContentController extends Component<Props> {
  public constructor(props: Props) {
    super(props);
    this.state = {};
  }

  public async componentDidMount(): Promise<void> {
    if (await AuthWrapper.isCurrentUserAuthenticated()) {
      await EventsRepository.instance.init();
      await OtaManager.getInstance().init();
    }
  }

  public componentWillUnmount(): void {
    EventsRepository.instance.uninit();
    OtaManager.getInstance().uninit();
  }

  public render(): JSX.Element {
    return (
      <section className="body-container col-sm-12 col-xsm-12">
        <Switch>
          <Route exact={true} path={Paths.ANALYTICS + "/:id?"}>
            <AnalyticsView />
          </Route>
          <Route exact={true} path={Paths.USER}>
            <UserView />
          </Route>
          <Route exact={true} path={Paths.SUPPORT + "/:organizationId?/:selectedTab?"}>
            <SupportView />
          </Route>
          <Route exact={true} path={Paths.ADMIN}>
            <AdminView />
          </Route>
          <Route exact={false} path={Paths.ROOT}>
            <Redirect to={Paths.SUPPORT} />
          </Route>
        </Switch>
      </section>
    );
  }
}
